let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cN3OU")).then(() => parcelRequire('8qRZP'));